import React from 'react';
import cn from 'classnames';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import selectFundsRibbon from '../../images/sf-certified-12.svg';
import lockIcon from '../../images/lock-icon.svg';
import Tooltip from '../Tooltip/Tooltip';
import unlockIcon from '../../images/unlock-icon.svg';
import { TRANSPARENCY_TYPES } from '../../utils/constants';
import styles from './RowTitle.css';
import { isFundUnlocked } from './utils';

export const Ticker = (props) => <div className="ticker" {...props} />;
export const Name = (props) => <span className="name" {...props} />;

/**
  RowTitle Component
*/
const RowTitle = ({
    name,
    ticker,
    moneyMarketType,
    tackedInceptionValues,
    iClass,
    inceptionDate,
    etf,
    openToNewInvestors,
    openToSubsequentInvestments,
    summitTier,
    isSelectFund,
    transparencyTypeName
}) => {
    // if not openToNewInvestors with select, personal, enahced_personal show unlock
    // if iClass and personal_service, enhanced_personal service show unlock
    // if not openToNewInvestors fund show lock icon.
    // always show lock if fund is buy restricted
    const lockData = {
        summitTier,
        iClass,
        openToNewInvestors,
        openToSubsequentInvestments
    };

    const unlocked = isFundUnlocked(lockData);

    const locked = !openToNewInvestors && !unlocked;

    const showLockIcon = !etf && (locked || unlocked);

    const icon = showLockIcon && (
        <React.Fragment>
            <Tooltip
                trigger="mouseenter"
                animation="none"
                content={
                    unlocked
                        ? 'Summit Program Benefit'
                        : 'Generally closed to new investors'
                }
            >
                <img
                    alt={
                        unlocked
                            ? 'Summit Program Benefit'
                            : 'Generally closed to new investors'
                    }
                    src={unlocked ? unlockIcon : lockIcon}
                    className={cn('lock', { open: unlocked })}
                />
            </Tooltip>

            <style jsx>{styles}</style>
        </React.Fragment>
    );

    return (
        <div className={cn('row-label', { etf })}>
            <a
                href={
                    etf
                        ? `/personal-investing/tools/fund-research/etf/${ticker}`
                        : `/personal-investing/tools/fund-research/${ticker}`
                }
                className="title-link"
            >
                <div className="ticker-row">
                    <div className="ticker">{ticker}</div>
                    {isSelectFund && (
                        <Tooltip
                            trigger="mouseenter"
                            animation="none"
                            content="T. Rowe Price® Select Fund"
                        >
                            <img
                                alt="Select Fund Certified"
                                src={selectFundsRibbon}
                            />
                        </Tooltip>
                    )}&nbsp;
                    {icon}
                </div>
                <span className="name">
                    {name && name.trim()}
                    {etf &&
                        transparencyTypeName === TRANSPARENCY_TYPES.SEMI &&
                        '\xa0*'}
                </span>
                {moneyMarketType === 'RETAIL' && <sup>&nbsp;5</sup>}
                {moneyMarketType === 'GOVERNMENT' && <sup>&nbsp;6</sup>}
                {tackedInceptionValues && <sup>&nbsp;^</sup>}
                {!etf &&
                    !openToNewInvestors && (
                        <div className="closed-fund">CLOSED</div>
                    )}
                {iClass && (
                    <div className="inception-date">
                        I-Class Inception Date - {inceptionDate}
                    </div>
                )}
            </a>
            <style jsx>{styles}</style>
        </div>
    );
};

RowTitle.propTypes = {
    name: PropTypes.node.isRequired,
    ticker: PropTypes.node.isRequired,
    moneyMarketType: PropTypes.string,
    tackedInceptionValues: PropTypes.bool,
    iClass: PropTypes.bool,
    inceptionDate: PropTypes.node
};

RowTitle.defaultProps = {
    moneyMarketType: '',
    tackedInceptionValues: false,
    iClass: false,
    inceptionDate: null
};

export default withRouter(RowTitle);
